export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Passwort"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stornieren"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Weiter"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geben Sie das Bestätigungspasswort ein"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigungspasswort"])}
}